import {DraftError} from './DraftError.js'

export class NotFoundDraftError extends DraftError {}
